import React from "react";

export default function Footer() {
    return(
        <footer style={{
            position:"relative",
            right: "0",
            bottom: "0",
            left: "0",
            padding:"15px",
            textAlign: "center",
            backgroundColor: "rgb(255, 212, 94)"
        }}>
            <small>©MemeBook</small>
        </footer>
    )
}